import { Component, OnInit, OnDestroy } from '@angular/core'
import { NgxSpinnerService } from 'ngx-spinner'
import { NotificationService } from './../../../services/notification.service'

@Component({
	selector: 'app-loading',
	templateUrl: './loading.component.html'
})
export class LoadingComponent implements OnInit, OnDestroy {
	constructor(
		private spinner: NgxSpinnerService,
		private notificationService: NotificationService
	) {}

	private init: any
	private stop: any

	public ngOnInit(): void {
		this.init = this.notificationService.starterLoading.subscribe(() =>
			this.spinner.show()
		)
		this.stop = this.notificationService.stopperLoading.subscribe(() =>
			this.spinner.hide()
		)
	}

	public ngOnDestroy(): void {
		try {
			this.init.unsubscribe()
			this.stop.unsubscribe()
		} catch (err) { }
	}
}
